import { theme } from "./Theme";

export const setThemeVariables = () => {
  const root = document.documentElement;

  // Get all palette groups, excluding default MUI ones
  const excludedGroups = [
    "secondary",
    "error",
    "warning",
    "info",
    "success",
    "grey",
    "mode",
    "divider",
  ]; // Add any you don't need
  const colorGroups = Object.keys(theme.palette).filter(
    (group) => !excludedGroups.includes(group),
  );

  // Loop through each group dynamically
  colorGroups.forEach((group) => {
    const colorGroup = theme.palette[group as keyof typeof theme.palette]; // Access group dynamically

    if (colorGroup) {
      Object.entries(colorGroup).forEach(([key, value]) => {
        if (typeof value === "string") {
          // For simple string-based colors (e.g., agricolors, agrimodal)
          root.style.setProperty(`--${group}-${key}`, value);
        } else if (typeof value === "object" && value.main) {
          // For color objects with `main`, `light`, `dark`, `contrastText`
          root.style.setProperty(`--${group}-${key}-main`, value.main);
          root.style.setProperty(`--${group}-${key}-light`, value.light || "");
          root.style.setProperty(`--${group}-${key}-dark`, value.dark || "");
          root.style.setProperty(
            `--${group}-${key}-contrastText`,
            value.contrastText || "",
          );
        }
      });
    }
  });
};
